export default __webpack_public_path__ + "static/media/O_orange.05f13572.png";